import PageLoading from './PageLoading'
export default {
  install: function(Vue) {
    // 全局注册loading组件
    const LoadConstructor = Vue.extend(PageLoading)
    let instance
    Vue.prototype.$loading = {
      show: () => {
        instance = new LoadConstructor()
        instance.$mount()
        // 生成DOM
        document.body.appendChild(instance.$el)
      },
      hide: () => {
        instance.$destroy()
        // 销毁DOM
        document.body.removeChild(instance.$el)
      }
    }
  }
}
